'use client';

import { RtItem } from '@dpa/react-item';
import { RtText } from '@dpa/react-text';
import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { ECountry } from '@portals/help-center-core';
import { Link } from '@/i18n/navigation';
import { TRecommendedArticle } from '@/api/get-recommended/_types';
import { getHref } from '@/_pages/advice-list/_components/new-advice-list/_components/help-center-link/_utils/get-href';
import { EPageType, EPositionBlock } from '@/_analytic/_types';
import { recommendedLinkClickEvent } from '@/_analytic/events/recommended-link-click-event';
import { IMaterial } from '@/_types';
import { useMaterialAnalyticData } from '@/_analytic/hooks/use-material-analytic-data';
import styles from './index.module.scss';

const BLOCK_NAME = 'Recommended-list';
const cn = classnames.bind(styles);

type TProps = {
  data: Array<TRecommendedArticle>;
  tapPosition: EPositionBlock;
  materialId: IMaterial['id'];
  materialTitle: IMaterial['title'];
  country: ECountry;
};

export const RecommendedList = ({
  materialId,
  materialTitle,
  data,
  tapPosition,
  country,
}: TProps) => {
  const materialAnalyticData = useMaterialAnalyticData({
    materialCategoryId: '',
    materialTitle,
    materialId,
  });

  const handleClick = (recommendedArticle: TRecommendedArticle) => () => {
    recommendedLinkClickEvent({
      ...materialAnalyticData,
      idRecArticle: recommendedArticle.id,
      nameRecArticle: recommendedArticle.title,
      tapPosition,
    });
  };
  const translations = useTranslations('article');
  const titleText = translations('recommendedTitle');

  return (
    <div className={cn(BLOCK_NAME)}>
      <RtText specification="main" typography="body-xs-regular">
        {titleText}
      </RtText>

      <div className={cn(`${BLOCK_NAME}__list`)}>
        {data.map((item) => {
          const href = getHref({
            pageType: EPageType.ADVICE_LIST_ARTICLE,
            idArticle: item.id,
            isRecommended: true,
            country,
          });

          return (
            <Link
              key={item.id}
              className={cn(`${BLOCK_NAME}__button`)}
              href={href}
              onClick={handleClick(item)}
              rel="noreferrer"
              target="_blank"
            >
              <RtItem
                subLabel={item.title}
                use="generic"
                cursor="pointer"
                size="lg"
              />
            </Link>
          );
        })}
      </div>
    </div>
  );
};
